import { Routes } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from './services/auth.service';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { EmailVerificationComponent } from './components/email-verification/email-verification.component';
import { QrScannerComponent } from './components/qr-scanner/qr-scanner.component';
import { LocationComponent } from './components/location/location.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { OrderRequestComponent } from './components/order-request/order-request.component';
import { NearbyRestaurantsComponent } from './components/nearby-restaurants/nearby-restaurants.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { MenuViewerComponent } from './components/menu-viewer/menu-viewer.component';
import { RestaurantMenuComponent } from './components/restaurant-menu/restaurant-menu.component';
import { OrderConfirmationComponent } from './components/order-confirmation/order-confirmation.component';
import { ChatComponent } from './components/chat/chat.component';
import { ProximityComponent } from './components/proximity/proximity.component';
import { OAuthCallbackComponent } from './components/oauth-callback/oauth-callback.component';
import { PedirComponent } from './components/pedir/pedir.component';
import { BusinessDetailComponent } from './components/business-detail/business-detail.component';
import { OrderHistoryComponent } from './components/order-history/order-history.component';
import { ActivateAccountComponent } from './components/activate-account/activate-account.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { PublicBusinessComponent } from './components/public-business/public-business.component';

// Auth Guard
const authGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  
  return authService.isAuthenticated$.pipe(
    map(isAuthenticated => {
      console.log('AuthGuard: isAuthenticated =', isAuthenticated);
      if (!isAuthenticated) {
        // Save return URL — prefer restaurant-menu if cart has data
        const saved = sessionStorage.getItem('barclik_public_menu');
        if (saved) {
          sessionStorage.setItem('barclik_return_url', '/restaurant-menu');
        }
        router.navigate(['/login']);
        return false;
      }
      console.log('AuthGuard: Usuario autenticado, permitiendo acceso');
      return true;
    })
  );
};

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'verify-email', component: EmailVerificationComponent },
  { path: 'activate', component: ActivateAccountComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'auth/:provider/callback', component: OAuthCallbackComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
  { path: 'order-request', component: OrderRequestComponent, canActivate: [authGuard] },
  { path: 'nearby-restaurants', component: NearbyRestaurantsComponent, canActivate: [authGuard] },
  { path: 'business/:id', component: BusinessDetailComponent, canActivate: [authGuard] },
  { path: 'user-profile', component: UserProfileComponent, canActivate: [authGuard] },
  { path: 'scanner', component: QrScannerComponent, canActivate: [authGuard] },
  { path: 'location', component: LocationComponent, canActivate: [authGuard] },
  { path: 'menu/:localId', component: MenuViewerComponent, canActivate: [authGuard] },
  { path: 'menu/:localId/table/:tableId', component: MenuViewerComponent, canActivate: [authGuard] },
  { path: 'restaurant-menu', component: RestaurantMenuComponent },  // No auth — accessible from public view
  { path: 'order-confirmation', component: OrderConfirmationComponent, canActivate: [authGuard] },
  { path: 'chat', component: ChatComponent, canActivate: [authGuard] },
  { path: 'proximity', component: ProximityComponent, canActivate: [authGuard] },
  { path: 'buscar', component: PedirComponent, canActivate: [authGuard] },
  { path: 'order-history', component: OrderHistoryComponent, canActivate: [authGuard] },
  // Public business profile (no login required)
  { path: 'local/:slug', component: PublicBusinessComponent },
  { path: '**', redirectTo: '/' }
];
